// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202609021408/js/" + chunkId + "." + {"44":"10f3a83f","225":"8044974b","481":"93c6f378","486":"d007de62","770":"7f89c25c"}[chunkId] + ".0.4114950988763695.chunk.js";
};